import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { modifyBalanceAdmin } from '../../actions/adminBilling.action';
import swal from 'sweetalert';

const UserBillingBlock = ({ userDetails, setTypeModal }) => {
    const dispatch = useDispatch();
    const loading = useSelector(state => state.adminBilling?.loading);
    const [amount, setAmount] = useState('');
    const [description, setDescription] = useState('');

    const handleModify = async () => {
        if (!amount || !description) {
            swal("Внимание", "Заполните сумму и причину", "warning");
            return;
        }

        const success = await dispatch(modifyBalanceAdmin('User', userDetails._id, amount, description));
        if (success) {
            setAmount('');
            setDescription('');
        }
    };

    if (!userDetails) return null;

    return (
        <div style={{ padding: '20px' }}>
            <div style={{ marginBottom: '20px', padding: '15px', background: '#f5f5f5', borderRadius: '8px' }}>
                <h4 style={{ margin: 0 }}>Текущий баланс: <span style={{ color: '#23d160', fontSize: '24px' }}>{userDetails.balance || 0} ₽</span></h4>
                <p style={{ margin: '5px 0 0 0', color: '#666' }}>
                    Подписка: {userDetails.subscription?.type === 'none' ? 'Отсутствует' : userDetails.subscription?.type}
                </p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontSize: '14px', color: '#333', marginBottom: '5px' }}>Сумма (используйте минус для списания, напр: -500)</label>
                    <input
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px' }}
                    />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontSize: '14px', color: '#333', marginBottom: '5px' }}>Причина (например: Бонус за регистрацию / Корректировка)</label>
                    <input
                        type="text"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px' }}
                    />
                </div>

                <button
                    onClick={handleModify}
                    disabled={loading || !amount || !description}
                    style={{
                        padding: '12px',
                        background: (loading || !amount || !description) ? '#ccc' : '#121212',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: (loading || !amount || !description) ? 'not-allowed' : 'pointer',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        marginTop: '10px'
                    }}
                >
                    {loading ? "Обработка..." : "Изменить баланс"}
                </button>
            </div>

            <div style={{ marginTop: '20px', textAlign: 'right' }}>
                <button
                    style={{ background: 'transparent', border: 'none', color: '#888', cursor: 'pointer', fontSize: '16px' }}
                    onClick={() => setTypeModal("")}
                >
                    Назад к профилю
                </button>
            </div>
        </div>
    );
};

export default UserBillingBlock;